/** @returns {'auto' | 'api' | 'local'} */
export function getWorkspacesMode() {
  const raw = String(import.meta.env.VITE_WORKSPACES_MODE ?? 'auto').trim().toLowerCase()
  if (raw === 'api' || raw === 'local') return raw
  return 'auto'
}
